import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    TextField,
    MenuItem,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { useNotification } from "../../../hooks/useNotification";
import { updateUniversityRatingStatus } from "../../../api/universityApi";

const statusOptions = ["approved", "rejected",];

export default function UpdateRatingStatusModal({ refetch, review, open, onClose }) {
    const [newStatus, setNewStatus] = useState("Pending");
    const [saving, setSaving] = useState(false)
    const {showSuccessNotification, showErrorNotification } = useNotification()

    const handleUpdate = () => {
        setSaving(true)
        updateUniversityRatingStatus(review?.id, newStatus?.toLowerCase())
            .then(res => { 
                onClose(); refetch(); setSaving(false)
                showSuccessNotification(res?.message)
            })
            .catch(error => {
                showErrorNotification(error?.message)
                setSaving(false)
            })
    };

    useEffect(()=>{
        if(statusOptions?.includes(review?.status)){
            setNewStatus(review?.status)
        }else{
            setNewStatus("pending")
        }
    },[review])


    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: { borderRadius: "16px" },
            }}
        >
            {/* Title with Close Button */}
            <DialogTitle
                sx={{
                    m: 0,
                    p: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography sx={{ fontWeight: 600, fontSize: "20px", color: "#15243E" }}>
                    Update Review Status
                </Typography>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            {/* Content */}
            <DialogContent>
                {/* Student Details */}
                <Box mb={2}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                        <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", py: 0.5 }}>
                            Student: <Typography variant="span" sx={{ fontWeight: "normal" }}>{review?.studentDetails}</Typography>
                        </Typography>
                        <Typography variant="span" sx={{ background: '#FFECA0',textTransform:"capitalize", border: '1px solid #FFE187', color: '#FF6E20', fontSize: '12px', borderRadius: '20px', px: 2, }}>{review?.status}</Typography>
                    </Box>
                    <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", py: 0.5 }}>
                        University: <Typography variant="span" sx={{ fontWeight: "normal" }}>{review?.universityName}</Typography>
                    </Typography>
                    <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", py: 0.5 }}>
                        Rating: <Typography variant="span" sx={{ fontWeight: "normal" }}>{review?.rating}</Typography>
                    </Typography>
                    <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", py: 0.5 }}>
                        Review: <Typography variant="span" sx={{ fontWeight: "normal" }}>{review?.review}</Typography>
                    </Typography>
                </Box>

                {/* New Status */}
                <Box mb={2}>
                    <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", mb: 1 }}>
                        Status
                    </Typography>
                    <TextField
                        select
                        fullWidth
                        value={newStatus}
                        onChange={(e) => setNewStatus(e.target.value)}
                        variant="outlined"
                        sx={{
                            "& .MuiInputBase-root": {
                                height: 40, fontSize: '14px',
                            },
                            "& .MuiSelect-select": {
                                display: "flex",
                                alignItems: "center",
                                height: "100%",
                                padding: "0 14px",
                            },
                            textTransform:'capitalize'
                        }}
                    >
                        {statusOptions.map((status) => (
                            <MenuItem key={status} value={status} sx={{textTransform:'capitalize'}}>
                                {status}
                            </MenuItem>
                        ))}
                    </TextField>
                </Box>

            </DialogContent>

            {/* Footer Actions */}
            <DialogActions sx={{ px: 3, pb: 3 }}>
                <Button onClick={onClose} variant="outlined" sx={{ width: "100%", height: "50px" }}>
                    Cancel
                </Button>
                <Button
                    onClick={handleUpdate}
                    variant="contained"
                    loading={saving}
                    disabled={!newStatus || saving}
                    sx={{ background: "#1075FF", width: "100%", height: "50px", "&:hover": { background: "#0d63d6" } }}
                >
                    Update Status
                </Button>
            </DialogActions>
        </Dialog>
    );
}
